import React from "react"

import userStore from "userStore"
import Loading from "components/Loading"

/**
 * BDSJEA-14: este componente YA NO decide si una pantalla se ve.
 *
 * Antes lo hacía, y fallaba abierto: recorría los permisos del usuario buscando
 * uno cuyo nombre coincidiera con la ruta y, si no encontraba ninguno, dejaba
 * pasar. Como los perfiles solo traen los objetos que tienen concedidos, el caso
 * normal (el usuario no tiene el permiso) era justamente el que no bloqueaba.
 * Escribiendo la URL a mano se entraba a cualquier pantalla.
 *
 * Tenía además dos problemas menores que venían del mismo diseño: comparaba
 * `nombreObjeto` contra el pathname, que son cosas distintas ("Agro->Administracion"
 * nunca va a igualar a "agro/admin"), y el efecto dependía solo de la cantidad de
 * permisos, así que al navegar entre pantallas no se recalculaba nada.
 *
 * La decisión de acceso ahora vive en Authmiddleware, que falla cerrado y exige
 * que cada ruta declare contra qué se valida. Acá solo queda mostrar el loader y
 * cubrir el caso del usuario sin ningún permiso, que no tiene nada que hacer
 * adentro de la aplicación.
 */
export default function Permission({ children, RenderError, permisos }) {
  const loading = userStore(state => state.loading)

  if (loading) {
    return <Loading loading={true} />
  }

  if (!permisos || permisos.length === 0) {
    return <RenderError />
  }

  return children
}
